// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2vyZo","colCheckbox":"styles_colCheckbox__lYYYj"};